<script setup lang="ts">
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

import { BaseAvatar, getDisplayName, getInitials } from '@magma-app/magma-lapilli';

const props = defineProps<{
  helper?: {
    firstname: string;
    lastname: string;
    profilePictureUrl?: string;
  };
  organizationName?: string;
  firstname?: string;
}>();

const { locale, t } = useI18n({ useScope: 'global' });

const helperFullName = computed(() => {
  if (!props.helper) return '';
  return getDisplayName(props.helper.firstname, props.helper.lastname);
});

const helperFallback = computed(() => {
  if (!props.helper) return '';
  return getInitials(props.helper.firstname, props.helper.lastname);
});
</script>

<template>
  <div class="px-5 pt-10 md:px-10">
    <svg
      class="mx-auto"
      width="56"
      height="56"
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="4" y="4" width="48" height="48" rx="24" fill="#D1FADF" />
      <path
        d="M36 22L25 33L20 28"
        stroke="#03874C"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <rect
        x="4"
        y="4"
        width="48"
        height="48"
        rx="24"
        stroke="#ECFDF3"
        stroke-width="8"
      />
    </svg>

    <h2
      class="mx-auto mt-4 text-center text-mgm-txt-lg font-medium text-foreground-emphasis"
    >
      {{
        `${t('generic.thanks')} ${firstname || ''}${locale === 'fr' ? ' ' : ''}!`
      }}
    </h2>

    <p
      class="mx-auto mt-2 text-center text-mgm-txt-sm font-normal text-foreground-default"
    >
      {{ `${t('helpeeSharingView.redirection')} ${organizationName}.` }}
    </p>

    <div class="mt-[42px] flex items-center pb-1">
      <BaseAvatar
        v-if="helper"
        class="h-8 w-8"
        :src="helper.profilePictureUrl"
        :alt="`${t('generic.profilePicture')} ${helperFullName}`"
        :fallback="helperFallback"
      />

      <p class="ml-2">
        <span
          class="block text-mgm-txt-sm font-medium text-foreground-emphasis"
        >
          {{ helperFullName }}
        </span>

        <span class="block text-mgm-txt-xs font-normal text-foreground-default">
          {{ `Helper ${organizationName}` }}
        </span>
      </p>
    </div>
  </div>
</template>
